import TablePagination from "@material-ui/core/TablePagination";
import React from "react";
import useList from "../Provider/hooks/useList";
import usePagination from "../Provider/hooks/usePagination";
import { LogPaginationFC } from "./types";

const LogPagination: LogPaginationFC = () => {
  const { page, perPage, isLastPage, updatePerPage, updatePage } =
    usePagination();
  const { isLoading } = useList();
  const handlerPageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    updatePage(page);
  };
  //@ts-ignore
  const handlerPerPageChange: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  > = ({ target: { value } }) => {
    updatePerPage(+value);
  };
  return (
    <>
      <TablePagination
        labelRowsPerPage={"Записей на страницу:"}
        labelDisplayedRows={({ page }) => `Страница ${page + 1}`}
        component="div"
        count={-1}
        page={page}
        onPageChange={handlerPageChange}
        rowsPerPage={perPage}
        onRowsPerPageChange={handlerPerPageChange}
        nextIconButtonProps={{
          disabled: isLastPage === true || isLoading === true ? true : false,
        }}
        backIconButtonProps={{
          disabled: isLoading === true || page <= 0 ? true : false,
        }}
        SelectProps={{
          disabled: isLoading === true ? true : false,
        }}
      />
    </>
  );
};

export default LogPagination;
